<template>
  <div>
    <!-- Name Input -->
    <div class="col form-group mb-4">
      <input
        ref="nameInput"
        id="name"
        v-model="obj.guardian.firstName"
        class="w-100 c-input"
        :placeholder="
          !config.fullNameOneInput == true ? 'Nome do responsável' : 'Nome completo do responsável'
        "
        type="text"
      />
    </div>
    <!-- Surname Input -->
    <div v-if="!config.fullNameOneInput == true" class="col form-group mt-5">
      <input
        ref="nameInput"
        id="surname"
        v-model="obj.guardian.surname"
        class="w-100 c-input"
        placeholder="Sobrenome do responsável"
        type="text"
      />
    </div>

    <!-- cpf Input -->
    <div class="col form-group mt-5">
      <input
        ref="cpf"
        id="cpf"
        v-model="obj.guardian.cpf"
        v-mask="'###.###.###-##'"
        class="w-100 c-input"
        placeholder="CPF do responsável"
        type="text"
        @keyup.enter="validateFields"
      />
    </div>

    <!-- email Input -->
    <div class="col form-group mt-5">
      <input
        id="email"
        v-model="obj.guardian.email"
        class="w-100 c-input"
        placeholder="E-mail do responsável"
      />
    </div>

    <!-- Phone Input -->
    <div class="col form-group mt-5">
      <input
        ref="phoneInput"
        id="phone"
        v-model="obj.guardian.phone"
        v-mask="'(##) #####-####'"
        class="w-100 c-input"
        placeholder="Celular do responsável"
        type="tel"
      />
    </div>

    <!-- Gender Input -->
    <div class="col form-group mt-4">
      <label class="mb-1"> Gênero do responsável </label>

      <div class="ml-4 w-100 form-group form-radio left-align">
        <input
          id="masculino"
          :key="key"
          v-model="obj.guardian.gender"
          class="form-check-input mt-2"
          type="radio"
          value="M"
          @change="key++"
        />

        <label for="masculino" class="mt-2 ml-1"> Masculino </label>

        <br />

        <input
          id="feminino"
          :key="key"
          v-model="obj.guardian.gender"
          class="form-check-input"
          type="radio"
          value="F"
          @change="key++"
        />

        <label for="feminino" class="ml-1"> Feminino </label>

        <br />

        <input
          id="outro"
          :key="key"
          v-model="obj.guardian.gender"
          class="form-check-input"
          type="radio"
          value="N"
          @change="key++"
        />

        <label for="outro" class="ml-1"> Outro </label>
      </div>
    </div>

    <div class="col form-group mt-3">
      <label class="mb-1"> Qual é o grau de parentesco? </label>

      <div class="ml-4 w-100 form-group form-radio left-align">
        <input
          id="father"
          :key="key"
          v-model="degree"
          class="form-check-input mt-2"
          type="radio"
          :value="'pai'"
          @change="key++"
        />

        <label for="father" class="mt-2 ml-1"> Pai </label>

        <br />

        <input
          id="mother"
          :key="key"
          v-model="degree"
          class="form-check-input"
          type="radio"
          :value="'mãe'"
          @change="key++"
        />

        <label for="mother" class="ml-1"> Mãe </label>

        <br />

        <input
          id="other"
          :key="key"
          v-model="degree"
          class="form-check-input"
          type="radio"
          :value="'other'"
          @change="key++"
        />

        <label for="other" class="ml-1"> Outro </label>

        <br />
      </div>
    </div>

    <div v-if="degree == 'other'" class="col form-group mb-4">
      <input
        ref="nameInput"
        id="name"
        v-model="obj.guardian.degree"
        class="w-100 c-input"
        :placeholder="'Grau de parentesco'"
        type="text"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { mask } from 'vue-the-mask'

export default {
  name: 'guardian',
  mask: {
    ...mask,
    tokens: {
      ...mask.tokens,
      null: /./,
    },
  },
  props: {
    validate: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    obj: {},
    degree: '',
  }),
  computed: {
    ...mapState(['config', 'registrationObject', 'subdomain', 'template']),
  },
  watch: {
    validate(newValue) {
      if (newValue) this.validateFields()
    },
  },
  mounted() {
    // Create a deep copy of the object of the store
    this.obj = JSON.parse(JSON.stringify(this.registrationObject))
    if (!this.obj.guardian) {
      this.obj.guardian = {}
    } else {
      this.degree = this.obj.guardian.degree
    }
    document.getElementById('passport').focus()
  },
  methods: {
    ...mapMutations([
      'updateRegistrationObject',
      'clearRegistrationErrors',
      'addRegistrationError',
    ]),

    validateFields() {
      this.$emit('validating')
      this.clearRegistrationErrors()
      let hasErrors = false

      if (!this.obj.guardian.firstName) {
        hasErrors = true

        this.addRegistrationError({ msg: 'É necessário informar seu nome.' })
      }

      if (!this.obj.guardian.surname) {
        hasErrors = true

        this.addRegistrationError({
          msg: 'É necessário informar o seu sobrenome.',
        })
      }

      if (!this.checkCPF(this.obj.guardian.cpf)) {
        this.addRegistrationError({
          msg: 'Informe um CPF válido.',
        })

        hasErrors = true
      }

      if (!this.obj.guardian.phone) {
        this.addRegistrationError({
          msg: 'É necessário informar um telefone.',
        })

        hasErrors = true
      }

      if (!this.validatePhone(this.obj.guardian.phone)) {
        this.addRegistrationError({
          msg: 'Informe um telefone válido.',
        })

        hasErrors = true
      }

      if (!this.obj.guardian.gender || this.obj.gender === 'g') {
        hasErrors = true

        this.addRegistrationError({
          msg: 'É necessário informar o gênero.',
        })
      }

      if (!this.degree) {
        hasErrors = true

        this.addRegistrationError({
          msg: 'É necessário informar o grau de parentesco.',
        })
      }

      if (this.degree == 'other') {
        if (!this.obj.guardian.degree) {
          hasErrors = true
          this.addRegistrationError({
            msg: 'É necessário informar o grau de parentesco.',
          })
        }
      } else {
        if (this.degree) {
          this.obj.guardian.degree = this.degree
        }
      }

      if (!hasErrors) {
        this.$store.commit('updateRegistrationObject', this.obj)

        this.$emit('next')
      }
    },

    checkCPF(value) {
      if (!value || !value.length) return false

      let cpf = value.replace(/[^\d]/g, '')

      if (
        cpf === '00000000000' ||
        cpf === '11111111111' ||
        cpf === '22222222222' ||
        cpf === '33333333333' ||
        cpf === '44444444444' ||
        cpf === '55555555555' ||
        cpf === '66666666666' ||
        cpf === '77777777777' ||
        cpf === '88888888888' ||
        cpf === '99999999999'
      ) {
        return false
      }

      let sum
      let remainder
      let i

      sum = 0

      for (i = 1; i <= 9; i++) {
        sum = sum + parseInt(cpf.substring(i - 1, i)) * (11 - i)
      }

      remainder = (sum * 10) % 11

      if (remainder === 10 || remainder === 11) {
        remainder = 0
      }

      if (remainder !== parseInt(cpf.substring(9, 10))) {
        return false
      }

      sum = 0

      for (i = 1; i <= 10; i++) {
        sum = sum + parseInt(cpf.substring(i - 1, i)) * (12 - i)
      }

      remainder = (sum * 10) % 11

      if (remainder === 10 || remainder === 11) {
        remainder = 0
      }

      if (remainder !== parseInt(cpf.substring(10, 11))) {
        return false
      }

      return true
    },

    validatePhone(phone) {
      return phone.length === 15
    },
  },
}
</script>
